import React, { Component } from 'react';

export default class AnimateOnMount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animate: false
        };
        // https://stanko.github.io/react-rerender-in-component-did-mount/    
        this.startAnimation = this.startAnimation.bind(this);

    }

    startAnimation(callback) {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                callback();
            });
        });
    }

    componentDidMount() {
        let t = this;
        this.startAnimation(() => {
            t.setState({ animate: true });
        });

    }
    componentWillUnmount() {
        this.setState({ animate: false });
    }
    render() {
        return (
            <div className={(this.state.animate) ? 'animate-wrapper animate' : 'animate-wrapper'}>
                {this.props.children}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/AnimateOnMount.js